import { render, staticRenderFns } from "./FeaturesHomeOne.vue?vue&type=template&id=1052b065"
import script from "./FeaturesHomeOne.vue?vue&type=script&lang=js"
export * from "./FeaturesHomeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports